module.exports = __webpack_public_path__ + "static/media/TitilliumWeb-Italic.a30e681e.ttf";